import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import RoleSelection from "@/pages/RoleSelection";
import DoctorApp from "@/pages/doctor/DoctorApp";
import HospitalDashboard from "@/pages/hospital/HospitalDashboard";
import AdminPanel from "@/pages/admin/AdminPanel";
import Dashboard from "@/pages/Dashboard";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/choose-role" element={<RoleSelection />} />
      <Route path="/doctor/*" element={<DoctorApp />} />
      <Route path="/hospital/*" element={<HospitalDashboard />} />
      <Route path="/admin/*" element={<AdminPanel />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}
